// extracted by mini-css-extract-plugin
export var list = "ArticleRatedFeaturesList-module--list--4Mlij";